import Helper from '@lovata/popup-helper';
import AirDatepicker from 'air-datepicker';
import Input from '../../form/input/input';

export default new class reservedClass {
  constructor() {
    this.panelSelector = 'reserved__panel';
    this.panelOpenContentSelector = 'reserved-content';
    this.panelOpenSelector = 'reserved-content__hidden';
    this.drawerCloseSelector = '_js-reserved-table';

    this.drawerBtnSelector = '_js-reserved-btn__open';
    this.drawerBtnMainSelector = '_js-reserved-btn__open-main';

    this.classFormSelector = 'reserved-info__form';
    this.inputPhoneSelector = 'input-phone__field';
    this.submitBtnSelector = 'reserved__submit';
    this.calendarClass = 'reserved__calendar';
    this.inValidSelector = '_invalid';

    this.successSelector = 'reserved__success';
    this.successVisibleSelector = 'reserved__success__visible';
    this.preLoaderSelector = 'reserved__preloader';
    this.dataExtraHoliday = 'data-reserved-days';

    this.isBasketPage = document.body.getAttribute('data-page-id') === 'basket';

    if (!this.isBasketPage) {
      this.init();
    }
  }

  init() {
    const div = document.createElement('div');
    const body = document.querySelector('body');
    div.classList.add(this.panelSelector);
    body.append(div);

    this.loadReservedPanel();
  }

  loadReservedPanel() {
    $.request('onAjax', {
      update: {
        'common/reserved/reserved-btn': `.${this.panelSelector}`,
      },
      complete: () => {
        this.handler();
        this.initCalend();
        this.initForm();
        this.initPhoneMask();
      },
    });
  }

  initPhoneMask() {
    Input.init();
    Input.handler();
    $(`.${this.inputPhoneSelector}`)
      .mask('+7 (999) 999-99-99');
  }

  initForm() {
    const form = document.querySelector(`.${this.classFormSelector}`);

    if (!form) return;

    const submitBtn = form.querySelector(`.${this.submitBtnSelector}`);

    submitBtn.addEventListener('click', () => {
      setTimeout(() => {
        this.checkForm(form);
      }, 0);
    });
  }

  checkForm(form) {
    const isValid = !form.classList.contains(this.inValidSelector);

    if (!isValid) return;

    $(form)
      .request('ReservationData::onSendData', {
        loading: `.${this.preLoaderSelector}`,
        complete: (res) => {
          this.showTooltip(res);
        },
      });
  }

  handler() {
    const modal = document.querySelector(`.${this.panelSelector}`);

    $(document).on('click', `.${this.drawerBtnSelector}`, ({ currentTarget }) => {
      const btn = document.querySelector(`.${this.drawerBtnSelector}`);
      const panel = $(currentTarget).parents(`.${this.panelSelector}`).children(`.${this.panelOpenContentSelector}`);
      const isOpen = !panel.hasClass(this.panelOpenSelector);

      Helper.setBodyScrollState(isOpen);
      Helper.overlayHandler(!isOpen, btn, modal);

      panel.toggleClass(this.panelOpenSelector);
    });

    $(document).on('click', `.${this.drawerBtnMainSelector}`, () => {
      const btn = document.querySelector(`.${this.drawerBtnMainSelector}`);
      const panel = $(`.${this.panelOpenContentSelector}`);
      const isOpen = !panel.hasClass(this.panelOpenSelector);

      Helper.setBodyScrollState(isOpen);
      Helper.overlayHandler(!isOpen, btn, modal);

      panel.toggleClass(this.panelOpenSelector);
    });
  }

  initCalend() {
    const extraHolidays = [];
    this.mediaQueryList = window.matchMedia('(min-width: 768px)');

    const button = {
      content: 'Сохранить',
      className: 'custom-button-classname',
      onClick: (dp) => {
        dp.hide();
      },
    };

    if (this.mediaQueryList.matches) {
      this.thisInline = true;
      this.thisMobile = false;
      this.thisButtons = false;
    } else {
      this.thisInline = false;
      this.thisMobile = false;
      this.thisButtons = [button, 'clear'];
    }

    const extraHolidayFields = document.querySelector(`.${this.calendarClass}`);
    if (extraHolidayFields.getAttribute(this.dataExtraHoliday).length > 0) {
      extraHolidayFields.getAttribute(this.dataExtraHoliday).split('|').forEach((_date) => {
        const extraHolidaysDate = new Date(_date);
        extraHolidays.push(extraHolidaysDate[Symbol.toPrimitive]('number'));
      });
    }

    const minDateReserved = new Date();

    // eslint-disable-next-line no-new
    new AirDatepicker(`.${this.calendarClass}`, {
      buttons: this.thisButtons,
      inline: this.thisInline,
      isMobile: this.thisMobile,
      multipleDates: false,
      showOtherMonths: false,
      startDate: false,
      timepicker: true,
      autoClose: false,
      position: 'top center',
      dateFormat: 'dd-MM-yyyy',
      minHours: 11,
      maxHours: 23,
      minutesStep: 10,
      minDate: minDateReserved,
      // eslint-disable-next-line consistent-return
      onRenderCell({ date, cellType }) {
        if (cellType === 'day') {
          const isDay = cellType === 'day';

          // Отключаем зарезервированные дни
          const setExtraHoliday = isDay && extraHolidays.includes(date[Symbol.toPrimitive]('number'));
          if (setExtraHoliday) {
            return {
              disabled: true,
              classes: 'disabled-class',
            };
          }

          return {
            disabled: false,
          };
        }
      },
    });
  }

  showTooltip(res) {
    clearTimeout(this.timer);
    const { responseJSON } = res;

    if (!responseJSON.message) return;

    const tooltip = document.querySelector(`.${this.successSelector}`);
    tooltip.classList.add(this.successVisibleSelector);
    if (!responseJSON.status) {
      tooltip.classList.add('tooltip__error');
    } else {
      tooltip.classList.remove('tooltip__error');
    }
    tooltip.innerHTML = responseJSON.message;

    this.timer = setTimeout(() => {
      tooltip.classList.remove(this.successVisibleSelector);
    }, 2000);
  }
}();
